var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.hasMap)?_c('span',{staticClass:"dot icon"}):_vm._e(),(_vm.mapCount >= 3)?_c('span',{staticClass:"icon"},[_vm._v("↑")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.mapName))]),(_vm.addComma)?_c('span',[_vm._v(", ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }